<template>
  <ul class="card-links">
    <li class="card-link__wrapper">
      <a
        v-if="company.address"
        :id="`business-card-${index}-address`"
        v-track-click="{ metadata: getClickMetadata('address') }"
        :href="`https://www.google.com/search?q=${formattedAddress(
          company.address,
          true,
        )}`"
        target="_blank"
        class="card-link card-link__address"
      >
        <t-icon
          height="16"
          width="16"
          :icon="addressIcon"
          class="card-link__icon"
        />
        <span>{{ formattedAddress(company.address, showCountryIso) }}</span>
      </a>
    </li>

    <li class="card-link__wrapper">
      <a
        v-if="company.website"
        :id="`business-card-${index}-website`"
        v-track-click="{ metadata: getClickMetadata('website') }"
        :href="company.website"
        target="_blank"
        :title="company.website"
        class="card-link card-link__website"
      >
        <t-icon
          height="16"
          width="16"
          :icon="websiteIcon"
          class="card-link__icon"
        />
        <span class="link-text">{{ extractDomain(company.website) }}</span>
      </a>
    </li>

    <li class="card-link__wrapper">
      <a
        v-if="company.email"
        :id="`business-card-${index}-email`"
        v-track-click="{ metadata: getClickMetadata('email') }"
        :href="`mailto:${company.email}`"
        target="_blank"
        class="card-link card-link__email"
      >
        <t-icon
          height="16"
          width="16"
          :icon="emailIcon"
          class="card-link__icon"
        />
        <span class="link-text">{{ company.email }}</span>
      </a>
    </li>

    <li class="card-link__wrapper">
      <a
        v-if="company.phone"
        :id="`business-card-${index}-phone`"
        v-track-click="{ metadata: getClickMetadata('phone') }"
        :href="`tel:${company.phone}`"
        target="_blank"
        class="card-link card-link__phone"
      >
        <t-icon
          height="16"
          width="16"
          :icon="phoneIcon"
          class="card-link__icon"
        />
        <span>{{ company.phone }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import { mdiEmail, mdiMapMarker, mdiPhone, mdiWeb } from '@mdi/js'

export default {
  name: 'ContactLinks',

  props: {
    /**
     * @type {object}
     * @property {object} address
     * @property {string} website
     * @property {string} email
     * @property {string} phone
     * @property {string} id
     * @property {string} name
     */
    company: {
      type: Object,
      required: true,
    },

    /**
     * @type {number}
     */
    index: {
      type: Number,
      required: true,
    },

    /**
     * @type {string}
     */
    partnerPlanLabel: {
      type: String,
      default: '',
    },

    /**
     * @type {Function}
     */
    getClickMetadata: {
      type: Function,
      required: true,
    },
  },

  /**
   * @returns {{addressIcon: string, emailIcon: string, phoneIcon: string, websiteIcon: string}}
   */
  data() {
    return {
      addressIcon: mdiMapMarker,
      emailIcon: mdiEmail,
      phoneIcon: mdiPhone,
      websiteIcon: mdiWeb,
    }
  },

  computed: {
    /**
     * @returns {boolean}
     */
    showCountryIso() {
      return (
        this.$store.getters['context/get']('country') !==
        this.company.address?.country
      )
    },
  },

  methods: {
    /**
     * @param {object} address
     * @param {boolean} includeCountry
     * @returns {string}
     */
    formattedAddress(address, includeCountry) {
      const {
        address: street,
        'house-number': houseNumber,
        'house-number-addition': houseNumberAddition,
        postal,
        city,
        country,
      } = address

      return `${street} ${houseNumber}${
        houseNumberAddition || ''
      }, ${postal} ${city}${includeCountry ? `, ${country.toUpperCase()}` : ''}`
    },

    /**
     * @param {string} url
     * @returns {string}
     */
    extractDomain(url) {
      try {
        const { hostname } = new URL(url)
        return hostname.replace(/^www\./, '')
      } catch {
        return url
      }
    },
  },
}
</script>
